import { render, staticRenderFns } from "./Thefiling.vue?vue&type=template&id=0cb281e4&scoped=true&"
import script from "./Thefiling.vue?vue&type=script&lang=js&"
export * from "./Thefiling.vue?vue&type=script&lang=js&"
import style0 from "./Thefiling.vue?vue&type=style&index=0&id=0cb281e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb281e4",
  null
  
)

export default component.exports